export default "__VITE_ASSET__44491d8b__"